export const getRegionCountry = ({ regionCountry }) => {
  return regionCountry
}
